import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-170acc40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-flex-column" }
const _hoisted_2 = { class: "campaign-list-counters" }
const _hoisted_3 = { class: "p-mb-4 p-mt-6" }
const _hoisted_4 = { class: "p-d-flex p-justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex align-items-center flex-column sm:flex-row p-mt-4"
}
const _hoisted_6 = { class: "p-d-flex p-align-center" }
const _hoisted_7 = { class: "campaign-name p-text-bold" }
const _hoisted_8 = { class: "p-d-flex p-align-center p-text-bold campaign-name" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "p-d-flex p-flex-column p-align-center p-justify-center" }
const _hoisted_11 = { class: "data-text" }
const _hoisted_12 = { class: "campaign-name" }
const _hoisted_13 = { class: "budget" }
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = { class: "budget" }
const _hoisted_16 = { class: "bold" }
const _hoisted_17 = { class: "budget" }
const _hoisted_18 = { class: "bold" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "p-d-flex"
}
const _hoisted_21 = { class: "p-flex-column p-mr-3" }
const _hoisted_22 = { class: "box-stats" }
const _hoisted_23 = { class: "budget p-d-block" }
const _hoisted_24 = { class: "bold" }
const _hoisted_25 = { class: "budget p-d-block" }
const _hoisted_26 = { class: "bold" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = { class: "box-stats" }
const _hoisted_29 = { class: "budget p-d-block" }
const _hoisted_30 = { class: "bold" }
const _hoisted_31 = { class: "budget p-d-block" }
const _hoisted_32 = { class: "bold" }
const _hoisted_33 = { class: "p-flex-column" }
const _hoisted_34 = { class: "box-stats" }
const _hoisted_35 = { class: "budget p-d-block" }
const _hoisted_36 = { class: "bold" }
const _hoisted_37 = { class: "budget p-d-block" }
const _hoisted_38 = { class: "bold" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { class: "p-flex-column" }
const _hoisted_41 = { class: "box-stats" }
const _hoisted_42 = { class: "budget p-d-block" }
const _hoisted_43 = { class: "bold" }
const _hoisted_44 = { class: "budget p-d-block" }
const _hoisted_45 = { class: "bold" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = {
  key: 0,
  class: "budget p-d-block"
}
const _hoisted_48 = { class: "bold" }
const _hoisted_49 = {
  key: 1,
  class: "budget p-d-block"
}
const _hoisted_50 = { class: "bold" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Change campaign status", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Change campaign budget", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "After editing the link, you need to wait some time for it to become active and working", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign rates", -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { class: "p-d-flex p-justify-between action-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampaignsCounterItem = _resolveComponent("CampaignsCounterItem")!
  const _component_GenericPrompt = _resolveComponent("GenericPrompt")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_StatusChip = _resolveComponent("StatusChip")!
  const _component_montly_earning_modal = _resolveComponent("montly-earning-modal")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_tracking_link_input = _resolveComponent("tracking-link-input")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CampaignsCounterItem, {
        name: 'Creators',
        counter: `${_ctx.creatorsCounts}`
      }, null, 8, ["counter"]),
      _createVNode(_component_CampaignsCounterItem, {
        name: 'Brands',
        counter: `${_ctx.brandsCount}`
      }, null, 8, ["counter"]),
      _createVNode(_component_CampaignsCounterItem, {
        name: 'Admins',
        counter: `${_ctx.adminsCount}`
      }, null, 8, ["counter"])
    ]),
    (_ctx.showAppliedCreatorsForSelectedCampaign && _ctx.apiCallFinished)
      ? (_openBlock(), _createBlock(_component_GenericPrompt, {
          key: 0,
          displayData: {
        htmlElementToUse: 'DataTable',
        content: _ctx.appliedCreatorsForSelectedCampaign,
        displayMultiple: true,
        columns: ['Email Address', 'Username'],
      },
          submitFunction: _ctx.appliedCreatorsOnClose
        }, null, 8, ["displayData", "submitFunction"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          type: "text",
          placeholder: "Search for Campaign",
          modelValue: _ctx.searchValueCampaign,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValueCampaign) = $event)),
          style: {"width":"80%"},
          class: "p-mr-3 search-input",
          onBlur: _ctx.searchCampaigns,
          onKeydown: _withKeys(_ctx.searchCampaigns, ["enter"])
        }, null, 8, ["modelValue", "onBlur", "onKeydown"]),
        _createVNode(_component_Button, {
          class: "search-bth",
          label: "search",
          onClick: _ctx.searchCampaigns
        }, null, 8, ["onClick"])
      ]),
      (_ctx.statuses)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (platform, index) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                key: index,
                label: platform.value,
                icon: platform.selected ? 'pi pi-check' : '',
                onClick: _withModifiers(($event: any) => (_ctx.addPlatform(platform)), ["prevent"]),
                class: _normalizeClass(["mr-2 mb-2 custom-chip p-mr-4 status-chip", [platform.selected ? 'selected' : '']])
              }, null, 8, ["label", "icon", "onClick", "class"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.campaignsList?.campaigns,
      responsiveLayout: "scroll",
      class: "p-mt-6 w-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "go",
          header: " "
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              class: "button-see-content button-go",
              label: "Go to campaign",
              onClick: ($event: any) => (
              _ctx.$router.push({
                name: 'campaign',
                params: { campaignID: data._id || data.id },
              })
            )
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "name",
          header: "Campaign",
          sortable: true
        }, {
          body: _withCtx((campaign) => [
            _createElementVNode("section", _hoisted_6, [
              (campaign.data && campaign.data.photo)
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    image: campaign.data?.photo,
                    class: "p-mr-2 photo"
                  }, null, 8, ["image"]))
                : (_openBlock(), _createBlock(_component_Avatar, {
                    key: 1,
                    image: _ctx.defaultImage,
                    class: "p-mr-2 photo"
                  }, null, 8, ["image"])),
              _createElementVNode("span", _hoisted_7, _toDisplayString(campaign.data.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "status",
          header: "Brand",
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: data.brand?.photo || _ctx.defaultImage,
                style: {"width":"30px","height":"30px","border-radius":"50%"},
                class: "p-mr-1"
              }, null, 8, _hoisted_9),
              _createTextVNode(" " + _toDisplayString(data.brand?.name), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "status",
          header: "Status",
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_StatusChip, {
                status: data.status,
                class: "p-mb-2"
              }, null, 8, ["status"]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDate(data.dates?.endDate) || 'Until Budget is Complete'), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "targetMarket.title",
          header: "Market"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_12, _toDisplayString(data?.targetMarket.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "paymentMethod",
          header: "Payment Method",
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(data?.paymentMethod || 'CPI'), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "budget.amount",
          header: "Budget",
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.compactNumber(data?.budget?.amount)), 1),
              _createTextVNode(" " + _toDisplayString(data.budget.currency), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "budget.amountLeft",
          header: "The remaining budget",
          sortable: true
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.compactNumber(data?.budget?.amount - data?.budget?.amountLeft)), 1),
              _createTextVNode(" " + _toDisplayString(data.budget.currency), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "For pay total conversions",
          header: "For pay"
        }, {
          body: _withCtx(({ data }) => [
            (_ctx.showMonthly === data?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_montly_earning_modal, { data: data }, null, 8, ["data"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showMonthly !== data?.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createTextVNode("IOS: "),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI || data?.paymentMethod === _ctx.CampaignPaymentMethod.CPM 
                      ? data?.forPay?.ios : 0), 1)
                      ]),
                      _createElementVNode("span", _hoisted_25, [
                        _createTextVNode("Total: "),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI || data?.paymentMethod === _ctx.CampaignPaymentMethod.CPM ?
                     (data?.forPay?.ios * data?.cpi?.ios?.amount) + " " + data?.budget?.currency : 0), 1)
                      ])
                    ]),
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, [
                        _createTextVNode("Android: "),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI || data?.paymentMethod === _ctx.CampaignPaymentMethod.CPM 
                      ? data?.forPay?.android : 0), 1)
                      ]),
                      _createElementVNode("span", _hoisted_31, [
                        _createTextVNode("Total: "),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI || data?.paymentMethod === _ctx.CampaignPaymentMethod.CPM ?
                     data?.forPay?.android * data?.cpi?.android?.amount  + " " + data?.budget?.currency : 0), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, [
                        _createTextVNode("Clicks: "),
                        _createElementVNode("span", _hoisted_36, _toDisplayString(data?.forPay?.clicks ? data.forPay.clicks : 0), 1)
                      ]),
                      _createElementVNode("span", _hoisted_37, [
                        _createTextVNode("Total: "),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC ? 
                    +data?.cpc?.amount * data?.forPay?.clicks + " " + data?.budget?.currency : 0), 1)
                      ])
                    ]),
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          _createTextVNode("View count: "),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPM ? data?.forPay.views : 0), 1)
                        ]),
                        _createElementVNode("span", _hoisted_44, [
                          _createTextVNode("Total: "),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(data?.paymentMethod === _ctx.CampaignPaymentMethod.CPM  && _ctx.campaignExpensesLoaded ? 
                     _ctx.getCurrentCampaignExpenses(data?._id)
                     : 0) + " " + _toDisplayString(data?.budget?.currency), 1)
                        ])
                      ])
                    ]),
                    _hoisted_46,
                    _createElementVNode("pre", null, "Applied: " + _toDisplayString(data?.trackingLinks?.length), 1),
                    (data?.paymentMethod === _ctx.CampaignPaymentMethod.CPI)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                          _createTextVNode("Total: "),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(+data?.cpi?.android?.amount * +data?.forPay?.android +
                    data?.forPay?.ios * data?.cpi?.ios?.amount), 1),
                          _createTextVNode(" " + _toDisplayString(data?.forPay?.currency), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (data?.paymentMethod === _ctx.CampaignPaymentMethod.CPC)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                          _createTextVNode("Total: "),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(data?.forPay?.clicks * data?.cpc?.amount), 1),
                          _createTextVNode(" " + _toDisplayString(data?.budget?.currency), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_51
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "action",
          header: "",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              class: "button-see-content",
              label: "See campaign content",
              onClick: ($event: any) => (
              _ctx.$router.push({
                name: 'campaign-content',
                params: { campaignId: data._id || data.id },
              })
            )
            }, null, 8, ["onClick"]),
            _hoisted_52,
            _createVNode(_component_Button, {
              class: "button-see-content",
              onClick: ($event: any) => {
              _ctx.openBasic = true;
              _ctx.selectedCampaignForActions = data;
            },
              label: "Actions for campaigns"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              class: "button-see-content",
              onClick: ($event: any) => {
              _ctx.showAppliedCreatorsForSelectedCampaign = true;
              _ctx.parseAppliedCreators(data?.trackingLinks);
            },
              label: "View applied creators"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Paginator, {
      rows: _ctx.limitCampaigns,
      totalRecords: _ctx.campaignsList?.pagination,
      onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPage($event)))
    }, null, 8, ["rows", "totalRecords"]),
    _createVNode(_component_Dialog, {
      header: `Campaign: ${_ctx.selectedCampaignForActions?.name}`,
      visible: _ctx.openBasic,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openBasic) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' }
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_Button, {
            label: "Cancel",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openBasic = false)),
            class: "p-button-text no"
          }),
          _createVNode(_component_Button, {
            label: "Save",
            icon: "pi pi-check",
            class: "yes",
            onClick: _ctx.updateCampaignData
          }, null, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_53,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, [
            _createTextVNode("Current status: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.selectedCampaignForActions?.status), 1)
          ]),
          _hoisted_54,
          _createElementVNode("span", null, [
            _createTextVNode("New status: "),
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.newCampaignStatus,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newCampaignStatus) = $event)),
              options: _ctx.changeStatus,
              optionLabel: "status",
              optionValue: "status",
              placeholder: "Select a campaign status",
              class: "p-mr-3"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Divider),
        _hoisted_55,
        _createElementVNode("div", null, [
          _createElementVNode("span", null, [
            _createTextVNode("Current campaign budget: "),
            _createElementVNode("b", null, _toDisplayString(_ctx.selectedCampaignForActions?.budget?.amount || 0) + " " + _toDisplayString(_ctx.selectedCampaignForActions?.budget?.currency), 1)
          ]),
          _hoisted_56,
          _createElementVNode("span", null, [
            _createTextVNode("New budget "),
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.newBudgetAmount,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newBudgetAmount) = $event)),
              mode: "decimal",
              minFractionDigits: 2
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_Divider),
        _createVNode(_component_tracking_link_input, { campaign: _ctx.selectedCampaignForActions }, null, 8, ["campaign"]),
        _hoisted_57,
        _createVNode(_component_Divider),
        _hoisted_58,
        _createElementVNode("div", null, [
          _createTextVNode(" Campaign type: " + _toDisplayString(_ctx.selectedCampaignForActions?.paymentMethod) + " ", 1),
          (
            _ctx.selectedCampaignForActions?.paymentMethod ===
            _ctx.CampaignPaymentMethod.CPM
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, " Rate: " + _toDisplayString(_ctx.selectedCampaignForActions?.cpm?.amount), 1))
            : _createCommentVNode("", true),
          (
            _ctx.selectedCampaignForActions?.paymentMethod ===
            _ctx.CampaignPaymentMethod.CPI
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, " Rates: Android - " + _toDisplayString(_ctx.selectedCampaignForActions?.cpi?.android?.amount) + "; IOS - " + _toDisplayString(_ctx.selectedCampaignForActions?.cpi?.ios?.amount), 1))
            : _createCommentVNode("", true),
          (
            _ctx.selectedCampaignForActions?.paymentMethod ===
            _ctx.CampaignPaymentMethod.CPC
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, " Rate: " + _toDisplayString(_ctx.selectedCampaignForActions?.cpc?.amount), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Divider)
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ]))
}